/**
 * 处理中浮层（全屏遮罩 + 转圈 + 一句在做什么）
 * -----------------------------------------------------------------------------
 * 为什么需要它：核验链上这几步都要**真人等 2~5 秒**（OCR 调百度、证件照要检测 +
 * 人像分割 + 合成），而它们原本唯一的反馈是「按钮变灰」。学员看到的是「点了没反应」，
 * 于是重复点、退出去重进，甚至以为卡死了 —— 尤其在证件照这一步，服务端要跑两次
 * 外部调用，等待是可感知的。
 *
 * 设计约束：
 *   ① **必须盖住整屏并吃掉点击**：等待期间任何重复提交都是白花钱的（每次 OCR /
 *      分割都是按次计费），也容易把状态机推到奇怪的中间态。
 *   ② 文案说「在做什么」而不是「请稍候」—— 后者不提供任何信息，学员不知道该不该等。
 *   ③ 不给取消按钮：这些请求都是不可中断的外部调用，给了取消也只是关掉浮层，
 *      后台照样在跑并计费，反而让人以为已经取消成功。
 *   ④ `aria-live="polite"` + `aria-busy`：读屏用户同样要能知道「现在在忙」。
 */
export interface ProcessingOverlayProps {
  visible: boolean;
  /** 正在做什么（动词短语，如「正在识别身份证」） */
  title: string;
  /** 补充说明：大概多久、别做什么 */
  hint?: string;
}

export function ProcessingOverlay({ visible, title, hint }: ProcessingOverlayProps) {
  if (!visible) return null;
  return (
    <div className="processing" role="status" aria-live="polite" aria-busy="true">
      <div className="processing__card">
        <span className="processing__ring" aria-hidden="true" />
        <p className="processing__title">{title}</p>
        {hint ? <p className="processing__hint">{hint}</p> : null}
      </div>
    </div>
  );
}
